/*
  Supermerci — cart drawer JS (giftwrap + upsells + drawer heropenen)
  Laden via layout/theme.liquid:
  <script src="{{ 'supermerci-cart.js' | asset_url }}" defer></script>
*/
(function () {
  if (window.__supermerciCart) return;
  window.__supermerciCart = true;
 
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = root + 'cart/add.js';
  var CHANGE_URL = root + 'cart/change.js';
  var UPDATE_URL = root + 'cart/update.js';
  var CART_URL = root + 'cart.js';
  var GIFTWRAP_VARIANT_ID = 56698211991938;
 
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error((data && data.description) || 'Cart error'); }
        return data;
      });
    });
  }
 
  function reloadAndReopen() {
    try { sessionStorage.setItem('sm-reopen-cart', '1'); } catch (err) {}
    window.location.reload();
  }
 
  /* ── Giftwrap ────────────────────────────────────────────── */
 
  function busy(on) {
    var el = document.querySelector('[data-giftwrap-busy]');
    if (el) el.classList.toggle('hidden', !on);
    var block = document.querySelector('[data-giftwrap-block]');
    if (block) block.style.pointerEvents = on ? 'none' : '';
  }
 
  function lineCheckboxes() {
    return Array.prototype.slice.call(document.querySelectorAll('.giftwrap-item'));
  }
 
  function lineRows() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-giftwrap-line]'));
  }
 
  function getCart() {
    return fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
 
  function removeWrap() {
    return getCart().then(function (cart) {
      var line = cart.items.filter(function (i) { return i.variant_id === GIFTWRAP_VARIANT_ID; })[0];
      if (!line) return null;
      return postJSON(CHANGE_URL, { id: line.key, quantity: 0 });
    });
  }
 
  function commit() {
    busy(true);
    var checked = lineCheckboxes().filter(function (b) { return b.checked; });
    var titles = checked.map(function (b) { return b.dataset.title; });
    var keys = checked.map(function (b) { return b.dataset.lineKey; });
 
    removeWrap()
      .then(function () {
        if (!checked.length) { return null; }
        return postJSON(ADD_URL, {
          items: [{
            id: GIFTWRAP_VARIANT_ID,
            quantity: 1,
            properties: {
              'Inpakken': titles.join(', '),
              '_wrap_keys': keys.join(',')
            }
          }]
        });
      })
      .then(reloadAndReopen)
      .catch(function (e) { console.error('Giftwrap error:', e); busy(false); });
  }
 
  function setRowsVisible(on) {
    lineRows().forEach(function (r) { r.classList.toggle('hidden', !on); });
    var help = document.querySelector('[data-giftwrap-help]');
    if (help) help.classList.toggle('hidden', !on);
  }
 
  /* ── Persoonlijke boodschap (cart.note, gratis) ──────────── */
 
  var noteTimer = null;
 
  function saveNote(value) {
    return postJSON(UPDATE_URL, { note: value })
      .catch(function (e) { console.error('Note error:', e); });
  }
 
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-note-input')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(t.value); }, 600);
  }, true);
 
  // Let op: 'true' = capture-fase. De drawer stopt event-bubbeling,
  // dus listeners in de bubble-fase op document worden nooit bereikt.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.hasAttribute && t.hasAttribute('data-note-toggle')) {
      var wrap = document.querySelector('[data-note-wrap]');
      var ta = document.querySelector('[data-note-input]');
      if (wrap) wrap.classList.toggle('hidden', !t.checked);
      if (t.checked) {
        if (ta) ta.focus();
      } else {
        if (ta) ta.value = '';
        clearTimeout(noteTimer);
        saveNote('');
      }
    } else if (t.hasAttribute && t.hasAttribute('data-giftwrap-master')) {
      setRowsVisible(t.checked);
      if (!t.checked) {
        var any = lineCheckboxes().some(function (b) { return b.checked; });
        lineCheckboxes().forEach(function (b) { b.checked = false; });
        if (any) { commit(); }
      }
    } else if (t.classList && t.classList.contains('giftwrap-item')) {
      commit();
    }
  }, true);
 
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('[data-giftwrap-selectall]')
      : null;
    if (btn) {
      e.preventDefault();
      lineCheckboxes().forEach(function (b) { b.checked = true; });
      commit();
    }
  }, true);
 
  /* ── Upsells ("Verwen jezelf") ───────────────────────────── */
 
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('[data-upsell-add]')
      : null;
    if (!btn) return;
 
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
 
    postJSON(ADD_URL, { items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
      .then(reloadAndReopen)
      .catch(function (err) {
        console.error('Upsell error:', err);
        btn.disabled = false;
        btn.textContent = label;
      });
  }, true);
 
  /* ── Drawer heropenen na reload ──────────────────────────── */
 
  var wantsReopen = false;
  try { wantsReopen = sessionStorage.getItem('sm-reopen-cart') === '1'; } catch (err) {}
  if (wantsReopen) {
    try { sessionStorage.removeItem('sm-reopen-cart'); } catch (err) {}
    var tries = 30;
    var tryOpen = function () {
      var stores = window.Alpine && window.Alpine.store ? window.Alpine.store('modals') : null;
      if (stores && typeof stores.open === 'function') {
        stores.open('cart');
      } else if (tries-- > 0) {
        setTimeout(tryOpen, 200);
      }
    };
    if (document.readyState === 'complete') { setTimeout(tryOpen, 200); }
    else { window.addEventListener('load', function () { setTimeout(tryOpen, 200); }); }
  }
})();